<template>
  <div class="favourite-view scroll-contents">
    <header>
      <h1>お気に入り</h1>
    </header>
    <div class="favourite-body">
      <div class="account-notify-message" v-if="!currentUser || currentUser.state !== 2">
        利用可能なユーザーがいません。
      </div>
      <div class="favourite-entries"
        v-for="entry in favouriteEntries"
        :key="'favoent'+ entry.id"
        >
        <div class="entry-info-block" @click="prepareCall(entry)">
          <div class="entry-icon"><user-portrate :target="entry" :displaySize="'middle'"/></div>
            <div class="entry-name">
              <div class="name">{{ entry.name }}</div>
              <div class="description" v-html="entryDescriptionHTML(entry)"></div>
            </div>
        </div>
        <div class="entry-action-block" @click="showEntryDetail(entry)">
          <img src="/images/information_icon.svg" />
        </div>
      </div>
    </div>
    <address-entry-detail-modal
      :addressEntryID="detailTargetEntryID"
      :modalDisplay="entryDetailDisplay"
      :returnLinkName="'お気に入り'"
      v-on:closeModalEvent="closeEntryDetailModal"
      v-on:prepareCallEvent="prepareCallFromDetail"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import AddressEntryDetailModal from '@/components/appView/addressBook/AddressEntryDetailModal.vue'

export default {
  name: 'FavouriteView',

  components: {
    AddressEntryDetailModal,
    UserPortrate,
  },

  emits: [
    'prepareCallEvent',
  ],

  data() {
    return {
      targetEntry: null,
      entryDetailDisplay: false,
      detailTargetEntryID: 0,
    }
  },

  mounted () {
    this.fetchAddressBook()
  },

  computed: {
    ...mapState({
      addressBook: state => state.addressBook.addressCategories,
      currentUser: state => state.user.currentUser,
    }),

    ...mapGetters({
      favouriteEntries: 'addressBook/favourites',
    }),
  },

  methods: {
    ...mapActions({
      fetchAddressBook: 'addressBook/fetch',
    }),

    entryDescriptionHTML (entry) {
      if (entry.description) {
        return entry.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    showEntryDetail (entry) {
      this.detailTargetEntryID = entry.id
      this.entryDetailDisplay = true
    },

    closeEntryDetailModal () {
      this.entryDetailDisplay = false
      this.detailTargetEntryID = 0
    },

    prepareCall(entry) {
      // TODO: move to prepare call
      console.log('prepare call, entry:' + entry)
      this.$emit('prepareCallEvent', this.currentUser.account_name, [entry])
    },

    prepareCallFromDetail(account_name, attendees) {
      this.$emit('prepareCallEvent', account_name, attendees)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.favourite-view {
  margin: 0;
  height: 100%;
  header {
    border-bottom: 1px solid #ddd;
  }
  .favourite-body {
    height: calc(100% - 65px);
    overflow: auto;
    .account-notify-message {
      padding: 50px 0;
      color: $danger-color;
      text-align: center;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
  .favourite-entries {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    .entry-info-block {
      flex-grow: 2;
      padding: 10px;
      display: flex;
      .entry-icon {
        width: 50px;
        height: 50px;
      }
      .entry-name {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name {
          font-size: 24px;
        }
        .description {
          font-size: 10pt;
        }
      }
    }
    .entry-action-block {
      display: flex;
      align-items: center;
      padding-right: 10px;
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
}
</style>